module.exports = __webpack_public_path__ + "img/empty-plans.fc5bf569.svg";